<!-- TODO: searchContainer is setting a fixed width, for this component I need to override it to make it dynamic -->
<div class="searchContainer" [style.width]="props.width || '100%'">
  <input
    aria-label="Search Bar"
    class="searchBox"
    autocomplete="no-autofill"
    [formControl]="control"
    [placeholder]="props.placeholder"
  />
  <em *ngIf="control.value" class="multiselect-clear pi pi-times-circle" (click)="clearFilter()"></em>
  <mat-icon class="search">search</mat-icon>
</div>
